import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { CheckCircle, XCircle, Loader2 } from 'lucide-react';
import { Button } from '../components/ui/button';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const NewsletterConfirmPage = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('loading');
  const [message, setMessage] = useState('');
  const token = searchParams.get('token');

  useEffect(() => {
    const confirmSubscription = async () => {
      if (!token) {
        setStatus('error');
        setMessage('Ungültiger Bestätigungslink.');
        return;
      }

      try {
        const response = await axios.post(`${BACKEND_URL}/api/newsletter/confirm`, { token });
        setStatus('success');
        setMessage(response.data.message);
      } catch (error) {
        setStatus('error');
        setMessage(error.response?.data?.detail || 'Bestätigung fehlgeschlagen.');
      }
    };

    confirmSubscription();
  }, [token]);

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: '#0B0F14' }}>
      <div className="max-w-md w-full mx-4">
        <div className="bg-[#1A1F26] rounded-xl p-8 text-center border border-white/10">
          {status === 'loading' && (
            <>
              <Loader2 className="w-16 h-16 mx-auto mb-4 text-blue-400 animate-spin" />
              <h1 className="text-2xl font-bold text-white mb-2">Bestätigung läuft...</h1>
              <p className="text-gray-400">Bitte warten Sie einen Moment.</p>
            </>
          )}

          {status === 'success' && (
            <>
              <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-green-500/20 flex items-center justify-center">
                <CheckCircle className="w-10 h-10 text-green-400" />
              </div>
              <h1 className="text-2xl font-bold text-white mb-2">Erfolgreich bestätigt!</h1>
              <p className="text-gray-400 mb-6">{message}</p>
              <Link to="/">
                <Button className="bg-gradient-to-r from-blue-500 to-cyan-400 hover:from-blue-600 hover:to-cyan-500">
                  Zur Startseite
                </Button>
              </Link>
            </>
          )}

          {status === 'error' && (
            <>
              <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-red-500/20 flex items-center justify-center">
                <XCircle className="w-10 h-10 text-red-400" />
              </div>
              <h1 className="text-2xl font-bold text-white mb-2">Bestätigung fehlgeschlagen</h1>
              <p className="text-gray-400 mb-6">{message}</p>
              <Link to="/">
                <Button variant="outline" className="border-white/10 text-white hover:bg-white/5">
                  Zur Startseite
                </Button>
              </Link>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default NewsletterConfirmPage;
